import { API_BASE_URL } from "@/api/api.config";
import { IMPLEMENTATION_GUIDE_API_BASE_URL } from "@/components/ImplementationGuide/constants";
import useRestQuery from "@/remoteState/useRestQuery";
import { CompletionRateData } from "../../types";

const useImplementationGuideCompletionRateGet = (districtUniqueId: string) => {
  const fullImplementationGuideApiUrl = `${API_BASE_URL}${IMPLEMENTATION_GUIDE_API_BASE_URL}${districtUniqueId}/completion-rate/`;

  return useRestQuery<CompletionRateData>(fullImplementationGuideApiUrl, {
    skip: !districtUniqueId,
  });
};

export default useImplementationGuideCompletionRateGet;
